import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PageName from "../../components/react_helmet/PageName";
import USAddressesTable from "../../components/table/USAddressesTable";
import { setThemeColor } from "../../store/actions/actions";
import { Button } from "reactstrap";

import toast from "react-hot-toast";

const SystemSettings = () => {
  const dispatch = useDispatch();
  const { themeColor } = useSelector((state) => state.redux);

  const resetTheme = () => {
    dispatch(setThemeColor('#00509d'));
    toast.success("Theme reset to default (#00509d)");
  };

  return (
    <div className="settings-container">
      <PageName title={"System Settings"} />

      <div className="settings-card mb-4 py-3 px-4 bg-white rounded shadow-sm border">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="fw-bold m-0" style={{ fontSize: '16px' }}>Theme Configuration</span>
          <Button color="secondary" outline size="sm" onClick={resetTheme} style={{ fontSize: '12px', padding: '4px 10px' }}>
            Reset Defaults
          </Button>
        </div>

        <div className="d-flex align-items-center gap-5">
          <div className="d-flex align-items-center gap-3">
            <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Primary Color</span>
            <input
              title="Select Primary Theme Color"
              type="color"
              value={themeColor || '#00509d'}
              onChange={(e) => dispatch(setThemeColor(e.target.value))}
              style={{ width: '35px', height: '35px', padding: 0, border: 'none', borderRadius: '6px', cursor: 'pointer' }}
            />
          </div>
        </div>
      </div>

      <div className="settings-card">
        <USAddressesTable />
      </div>
    </div>
  );
};

export default SystemSettings;
